<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <router-link class="navbar-brand" :to="{name: 'Home'}"><img src="https://edlservices.s3.eu-north-1.amazonaws.com/woodblocker/woodblocker-logo.svg" width="120px" alt="woodblock-logo"></router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
                <li class="nav-item active">
                    <router-link :to="{name: 'about'}" class="nav-link">About us</router-link>
                </li>
                <li class="nav-item active">
                    <router-link :to="{name: 'gallery'}" class="nav-link">Gallery</router-link>
                </li>

                <li class="nav-item active">
                    <router-link :to="{name: 'diffuser'}" class="nav-link">Sound Diffuser</router-link>
                </li>

                <li class="nav-item active">
                    <router-link :to="{name: 'eco'}" class="nav-link">Eco</router-link>
                </li>
            </ul>
        </div>
        <div class="form-inline my-2 my-lg-0">
            <button class="btn btn-primary my-2 my-sm-0" @click="logout">Αποσύνδεση</button>
        </div>
    </nav>

</template>
<script>
    export default{
        methods:{
            logout(){
                localStorage.removeItem('token');
                this.$router.push({name:'Login'});
            }
        }
    }
</script>